import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux"
import Select from 'react-select';
import { tagFunctions } from '../restaurants/Tags'
import { updateSortOptions } from '../../store/actions/restaurantActions'

function SearchBar() {

const [combinedSort, setCombinedSort] = useState([]);
const [sortCombined, setSortCombined] = useState([]);
const [options, setOptions] = useState(false);
const [sortName, setSortName] = useState(false);

const dispatch = useDispatch();

const restaurants = useSelector((state)=>state.firestore.ordered.restaurants);
const sortOptions = useSelector((state)=>state.restaurant.sortOptions);

useEffect(()=>{

	var options = tagFunctions.compileTags(restaurants);
	setOptions(options);
	var sortNames = [];
	var combined = [];
	for(var res in restaurants){
	  sortNames.push({"value":restaurants[res].name, "label":restaurants[res].name})
	}
	setSortName(sortNames);
	combined = sortNames.concat(options);
	setCombinedSort(combined);

},[restaurants])

useEffect(()=>{
if(sortCombined && sortOptions){
	let sortNames = sortCombined.filter(item => JSON.stringify(sortName).includes(JSON.stringify(item)))
	let sortTags = sortCombined.filter(item => JSON.stringify(options).includes(JSON.stringify(item)))
	dispatch(updateSortOptions({...sortOptions, sortCombined:sortCombined, sortName:sortNames, sortTags:sortTags, searchBar:true}))
	//console.log('dispatch')	
}
},[sortCombined])



	return(
	<div>
	{ sortOptions && 
		<Select isMulti style = {{"font-size":"16px"}} placeholder={'Search by Restaurant or Tag...'} options={combinedSort} value = {sortOptions.sortCombined} onChange={(e) => setSortCombined(e)}/>
	}
	</div>
	);
}

export default SearchBar;